var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:[{ active: _vm.$route.path.includes(_vm.routeGlobal)}],attrs:{"to":_vm.link}},[_c('div',{staticClass:"icon-w"},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7573529f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/user/partials/navbar/mobile/subMenu/MenuItem.vue
// module id = null
// module chunks = 